$(document).ready(function() {
  // navigation
  var scrollTop = 0;
  $(window).scroll(function(){
    scrollTop = $(window).scrollTop();

    // nav bar resize
    if ($('.navigation').hasClass('home-banner')) {
      if (scrollTop >= 80) {
        $('.navigation').addClass('scrolled-nav');
      } else if (scrollTop < 80) {
        $('.navigation').removeClass('scrolled-nav');
      }
    } else {
      if (scrollTop >= 50) {
        $('.navigation').addClass('scrolled-nav');
      } else if (scrollTop < 50) {
        $('.navigation').removeClass('scrolled-nav');
      }
    }
  });

  // if landing in the middle of the page, change nav to scrolled
  if ($(window).scrollTop() > 50) {
    $('.navigation').addClass('scrolled-nav');
  }
  $('#js-navigation-menu').removeClass('show');

  $('#js-mobile-menu').on('click', function() {
    document.getElementById('mobile-overlay').style.height = "100%";
    $('#js-navigation-menu').addClass('show');
    $(this).attr('aria-expanded', true);
  });

  $('#js-mobile-menu-close').on('click', function() {
    document.getElementById('mobile-overlay').style.height = "0%";
    $('#js-navigation-menu').removeAttr('style');
    $('#js-navigation-menu').removeClass('show');
    $('#js-mobile-menu').attr('aria-expanded', false);
  });

  // tabbable navigation
  var topLevelLinks = Array.prototype.slice.call(document.querySelectorAll('.nav-link > a'), 0);
  topLevelLinks.forEach(function(link) {
    link.addEventListener('focus', function() {
      this.parentElement.classList.add('focus');
    });
    if (link.nextElementSibling) {
      var subMenu = link.nextElementSibling
      var subMenuLinks = subMenu.querySelectorAll('a')
      var lastLinkIndex = subMenuLinks.length - 1
      var lastLink = subMenuLinks[lastLinkIndex]
      lastLink.addEventListener('blur', function() {
        link.parentElement.classList.remove('focus');
      });
    }
  });

  // product page change image on size change
  $('form').on('click', "input", function(e) {
    var imgUrl = $(this).data().imgUrl;
    var imgAlt = $(this).data().imgAlt;
    $('#ProductPhoto img').attr('src', imgUrl);
    $('#ProductPhoto img').attr('alt', imgAlt);
  });

  // home page change image on variant change
  $('.home-grid-item form, .cart-recommended-accessories form').on('click', "input", function(e) {
    var imgUrl = $(this).data().imgUrl;
    var imgId = $(this).data().imgId;
    $('#' + imgId + ' img').attr('src', imgUrl);
  });

  // accordion functions
  var bannerHeight = 70;

  function scrollToAnchor(anchorId) {
    var aTag = $("a[name='"+ anchorId +"']");
    $('html, body').animate({
      scrollTop: aTag.offset().top - bannerHeight
    }, 1000);
  }

  //scroll to tabs on page load  if there is a hash
  var hash = window.location.hash
  if (hash.length > 0 && hash !== '#site-content') {
    var split = hash.split('#')
    window.setTimeout(function() {
      scrollToAnchor(split[1]);
      $(hash + ' h3').click();
    }, 500);
  }

  //scroll to tabs when you click on this class
  $('.scroll-to-tab').on('click', function(e) {
    e.preventDefault();
    var hash = e.currentTarget.hash
    var split = hash.split('#');
    scrollToAnchor(split[1]);
    $(hash + ' h3').click();
  });

  $('.accordion .accordion-header').on('click', function(evt) {
    evt.preventDefault();
    var _this = $(this).parent('.accordion');
    _this.find('.accordion-inner').slideToggle();
    _this.find('.rightarrow').toggle();
    _this.find('.downarrow').toggle();
  });

  // bazaar voice reviews opening on click
  window.bvCallback = function (BV) {
    BV.reviews.on('show', function () {
      scrollToAnchor('reviews');
      if (!$('#reviews .accordion-inner').is(':visible')) {
        $('#reviews .accordion-header').click();
      }
    });
    // BV.questions.on('show', function () {});
  }

  //some old modal bullshit
  // videos
  $('.play-video').on('click', function(evt) {
    evt.preventDefault();
    var videoId = $(this).data().videoid;
    openModal('video');
    vimeoPlayer(videoId);
  });

  // closing modal
  $('.modal-fade-screen, .modal-close').on('click', function() {
    closeModal();
    if (player) {
      stopVideo();
    }
  });

  $('.modal-inner').on('click', function(e) {
    e.stopPropagation();
  });

  // shipping modal open
  $('.shipping-options').on('click', function() {
    openModal('shipping-gb');
  });

  // Cart page
  // if cart page get cart items
  /*
  if (window.location.pathname.indexOf('cart') >= 0) {
    var currentCart;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      dataType: 'json',
      success: function(cart) {
        currentCart = cart;
        if (window.location.hostname === 'store.alivecor.com' || window.location.hostname === 'dev-alivecor-us.myshopify.com') {
          searchCartKardiaCare(cart);
        } else {
          searchCartCarryPod(cart);
        }
      }
    });
  }
  */
  function searchCartOmron(cart) {
    var km_6l_in_cart = false,
        omron_in_cart = false;
    for (i = 0; i < currentCart.items.length; i ++) {
      if (currentCart.items[i].handle === 'kardiamobile' || currentCart.items[i].handle === 'kardiamobile6l') {
        km_6l_in_cart = true;
      }
      if (currentCart.items[i].handle === 'omron-evolv') {
        omron_in_cart = true;
      }
    }
    if (km_6l_in_cart && !omron_in_cart) {
      setTimeout(function() {
        showOmronOffer();
      }, 1500);
    }
  }
   function searchCartKardiaCare(cart) {
    var km_in_cart = false,
        km6l_in_cart = false,
        kardiacare_in_cart = false;
    for (i = 0; i < currentCart.items.length; i ++) {
      if (currentCart.items[i].handle === 'kardiamobile') {
        km_in_cart = true;
      }
      if (currentCart.items[i].handle === 'kardiamobile6l') {
        km6l_in_cart = true;
      }
      if (currentCart.items[i].handle === 'kardiacare') {
        kardiacare_in_cart = true;
      }
    }
    if ((km6l_in_cart || km_in_cart) && !kardiacare_in_cart) {
      setTimeout(function() {
        showKardiaCareOffer();
      }, 1500);
    }
    if (kardiacare_in_cart && !km_in_cart && !km6l_in_cart) {
     setTimeout(function() {
        showKardiaMobileOffer();
      }, 1500);
    }
  }
  function searchCartCarryPod(cart) {
    var km_in_cart = false,
        km_cp_in_cart = false,
        km6l_in_cart = false,
        km6l_cp_in_cart = false;
    for (i = 0; i < currentCart.items.length; i ++) {
      if (currentCart.items[i].handle === 'kardiamobile') {
        km_in_cart = true;
      }
      if (currentCart.items[i].handle === 'kardiamobile-carrypod') {
        km_cp_in_cart = true;
      }
      if (currentCart.items[i].handle === 'kardiamobile6l') {
        km6l_in_cart = true;
      }
      if (currentCart.items[i].handle === 'kardiamobile6l-carrypod') {
        km6l_cp_in_cart = true;
      }
    }
    if (km_in_cart && !km_cp_in_cart && !km6l_in_cart) {
      setTimeout(function() {
        showCarryPodOffer();
      }, 1500);
    }
    if (km6l_in_cart && !km6l_cp_in_cart) {
      setTimeout(function() {
        showCarryPod6lOffer();
      }, 1500);
    }
  }
  function showOmronOffer() {
    switch(window.location.hostname) {
      case 'store.alivecor.com':
        var omron_id = 31667890454593;
        break;
      case 'dev-alivecor-us.myshopify.com':
        var omron_id = 32200940290151;
        break;
      default:
        break;
    }
    $('.pop-up.omron').addClass('open');
    $('#omron-add').on('click', function() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          'quantity': 1,
          'id': omron_id
        },
        dataType: 'json',
        success: function() {
          location.reload();
        }
      });
    });
    $('#omron-no, #omron-close').on('click', function() {
      $('.pop-up.omron').removeClass('open');
    });
  }
  function showKardiaCareOffer() {
    switch(window.location.hostname) {
      case 'store.alivecor.com':
        var kardiacare_id = 32194082472001;
        break;
      case 'dev-alivecor-us.myshopify.com':
        var kardiacare_id = 32759436279911;
        break;
      default:
        break;
    }
    $('.pop-up.kardiacare-upsell').addClass('open');
    $('#kardiacare-upsell-add').on('click', function() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          'quantity': 1,
          'id': kardiacare_id
        },
        dataType: 'json',
        success: function() {
          location.reload();
        }
      });
    });
    $('#kardiacare-upsell-no, #kardiacare-upsell-close').on('click', function() {
      $('.pop-up.kardiacare-upsell').removeClass('open');
    });
  }
  function showKardiaMobileOffer() {
    switch(window.location.hostname) {
      case 'store.alivecor.com':
        var kardiamobile_id = 20036084615;
        break;
      case 'dev-alivecor-us.myshopify.com':
        var kardiamobile_id = 57806915659;
        break;
      default:
        break;
    }
    $('.pop-up.kardiamobile-upsell').addClass('open');
    $('#kardiamobile-upsell-add').on('click', function() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          'quantity': 1,
          'id': kardiamobile_id
        },
        dataType: 'json',
        success: function() {
          location.reload();
        }
      });
    });
    $('#kardiamobile-upsell-no, #kardiamobile-upsell-close').on('click', function() {
      $('.pop-up.kardiamobile-upsell').removeClass('open');
    });
  }
  function showKardiaMobile6LOffer() {
    switch(window.location.hostname) {
      case 'store.alivecor.com':
        var kardiamobile6l_id = 28007532101697;
        break;
      case 'dev-alivecor-us.myshopify.com':
        var kardiamobile6l_id = 20642078130279;
        break;
      default:
        break;
    }
    $('.pop-up.kardiamobile-upsell').addClass('open');
    $('#kardiamobile6l-upsell-add').on('click', function() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          'quantity': 1,
          'id': kardiamobile6l_id
        },
        dataType: 'json',
        success: function() {
          location.reload();
        }
      });
    });
    $('#kardiamobile6l-upsell-no, #kardiamobile6l-upsell-close').on('click', function() {
      $('.pop-up.kardiamobile-upsell').removeClass('open');
    });
  }
  function showCarryPodOffer() {
    switch(window.location.hostname) {
      case 'store.alivecor.com':
        var cp_id = 52407081427;
        break;
      case 'store.alivecor.co.uk':
        var cp_id = 4977985486887;
        break;
      case 'shop.de.alivecor.com':
        var cp_id = 14735901556785;
        break;
      case 'dev-alivecor-us.myshopify.com':
        var cp_id = 29056384073831;
        break;
      default:
        break;
    }
    $('.pop-up.km-carrypod').addClass('open');
    $('#km-carrypod-add').on('click', function() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          'quantity': 1,
          'id': cp_id
        },
        dataType: 'json',
        success: function() {
          location.reload();
        }
      });
    });
    $('#km-carrypod-no, #km-carrypod-close').on('click', function() {
      $('.pop-up.km-carrypod').removeClass('open');
    });
  }
  function showCarryPod6lOffer() {
    switch(window.location.hostname) {
      case 'store.alivecor.com':
        var cp6l_id = 29243799208001;
        break;
      case 'store.alivecor.co.uk':
        var cp6l_id = 29621855289416;
        break;
      case 'shop.de.alivecor.com':
        var cp6l_id = 16029382869041;
        break;
      case 'dev-alivecor-us.myshopify.com':
        var cp6l_id = 20769767522407;
        break;
      default:
        break;
    }
    $('.pop-up.km6l-carrypod').addClass('open');
    $('#km6l-carrypod-add').on('click', function() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          'quantity': 1,
          'id': cp6l_id
        },
        dataType: 'json',
        success: function() {
          location.reload();
        }
      });
    });
    $('#km6l-carrypod-no, #km6l-carrypod-close').on('click', function() {
      $('.pop-up.km6l-carrypod').removeClass('open');
    });
  }

  //Cookies stuff
  var acceptsCookies,
      closeCookieMsgBtn,
      cookiesMsg,
      disableKey,
      setCookie;

  // get cookie named accepts_cookies
  acceptsCookies = Cookies.get('accepts_cookies');

  closeCookieMsgBtn = $('#cookies-ok');

  cookiesMsg = $('#cookies-message');

  closeCookieMsgBtn.on('click', function(e) {
    return cookiesMsg.remove();
  });

  // cookie will expire after a year
  setCookie = function(value) {
    Cookies.set('accepts_cookies', value, {
      expires: 365,
      domain: 'alivecor.com'
    });
  };

  // accepts_cookies cookie exists
  if (acceptsCookies !== undefined) {
    // remove banner
    cookiesMsg.remove();
  } else {
    cookiesMsg.removeClass('hideBanner');
    setCookie(true);
  }

  //Newsletter signup
  var isEmail = function(email) {
    var regex;
    regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  };

  $("#mc-embedded-subscribe").on('click', function(e) {
    var email;
    $("footer .not-valid").hide();
    email = $("#mce-EMAIL").val();
    if (isEmail(email)) {
      var url = $("#mc-embedded-subscribe-form").prop('action');
      $.ajax({
        type: "GET",
        url: url,
        data: $("#mc-embedded-subscribe-form").serialize(),
        dataType: "json",
        crossDomain: true,
        success: function(data) {
          if (data.result == 'success') {
            $("footer .thankyou").fadeIn();
            var newsletterSubmitURL = window.location.protocol + '//' + window.location.host + window.location.pathname + '#newsletter-submit';
            window.location.href = newsletterSubmitURL;
          }
        }
      })
      .done(function(data) {
        if (data.result === 'error') {
          $("footer .error").html(data.msg).fadeIn();
        }
      });
    } else {
      $("footer .bad-email").fadeIn();
      return false;
    }
    e.preventDefault();
  });

  // listener for links to app
  $('.app-direct-link').on('click', function(evt) {
    evt.preventDefault();
    var link = $(this);

    // ios or android
    var agent = getUserAgent();
    if (agent !== '') {
      if (agent.indexOf('iphone') !== -1) {
        // ios device
        window.open(link.data().iosUrl, '_blank');
      } else {
        // not ios, assuming android
        window.open(link.data().androidUrl, '_blank');
      }
    } else {
      // could not get user agent
      window.open(link.attr('href'), '_blank');
    }
  });

  function getUserAgent() {
    var navigator = window.navigator;
    if (!navigator) {
      return '';
    }
    if (!navigator.userAgent) {
      return '';
    }
    return navigator.userAgent.toLowerCase();
  }

  $('.kardiacare-single__thumbnail').on('click', function(evt){
    evt.preventDefault();
    var newImage = $(this).attr('href');
    var newAlt = $(this).find('img').attr('alt');
    $('#ProductPhotoImg').attr('src', newImage);
    if (newAlt) {
      $('#ProductPhotoImg').attr('alt', newAlt);
    }
    $('.kardiacare-table table').hide();
    $('#ProductPhotoImg').show();
  });
  $('.kardiacare-table__thumbnail').on('click', function(evt) {
    evt.preventDefault();
    $('.kardiacare-table table').show();
    $('#ProductPhotoImg').hide();
  });

// show the welcome10 popup
function showWelcome10() {
  console.log("showing welcome 10");
  setTimeout(() => {
    const welcome10popup = document.getElementById('welcome10-popup');
    welcome10popup.style.display = 'flex';
    document.getElementsByTagName('body')[0].className += ' overflow-hidden h-screen'
  }, 3000);  
}

// hide the popup
function hideWelcome10() {
  document.getElementById('welcome10-popup').style.display = 'none';
  document.getElementsByTagName('body')[0].className -= ' overflow-hidden h-screen'
}

// use local storage to conditionally show popup
function checkWelcome10(){
  if(localStorage.getItem("welcome10shown")){
  }
  else{
    localStorage.setItem("welcome10shown", true);
    showWelcome10();
  }
}

checkWelcome10();
const welcome10close = document.getElementById("welcome-10-close");
welcome10close.addEventListener("click", function(e){
  hideWelcome10();
});

});

// video functions
var player;

function vimeoPlayer(id) {
  // player was already initialized
  if (player) {
    player.loadVideo(id).then(function() {
      playVideo();
      player.setColor('#2D9F86');
    });    
  } else {
    // first time playing a video
    var iframe = document.querySelector('#video-player iframe');
    iframe.src = 'https://player.vimeo.com/video/' + id;
    iframe.setAttribute('style', 'display: block');
    player = new Vimeo.Player(iframe);
    player.ready().then(function() {
      playVideo();
      player.setColor('#2D9F86');
    });
    
  }
  player.on('ended', function() {
    // close player when video ends
    player.unload();
    setTimeout(function() {
      closeModal();
    }, 500);
  });
}

function playVideo() {
  var isNotMobile = window.matchMedia("only screen and (min-width: 760px)");
  if (isNotMobile.matches) {
    player.play();
  }
}

function stopVideo() {
  player.pause();
  player.unload();
  player.off('ended');
}

//global modal functions
function openModal(type) {
  $('body').addClass("modal-open");
  $('.modal-fade-screen').addClass('open');

  if (type === 'video') {
    $('.modal-inner.video').show();
    $('.modal-inner.shipping-gb').hide();
  }
  if (type === 'shipping-gb') {
    $('.modal-inner.shipping-gb').show();
    $('.modal-inner.video').hide();
  }
}

function closeModal() {
  $('body').removeClass("modal-open");
  $('.modal-fade-screen').removeClass('open');
  $('.modal-inner').hide();
}

// Product-pre-order template
// PREORDER TEXT ON BUTTON CHANGE
function variantPreorderProduct() {
  $('.late-ship').show();
  $('#AddToCart').css('margin-bottom', '30px');
  $('#free-ship-benefit').html("Free Shipping");
  $('.product-description ul li:last-of-type').hide();
}
function variantForSaleProduct() {
  $('.late-ship').hide();
  $('#AddToCart').css('margin-bottom', '60px');
  $('#free-ship-benefit').html("Free Shipping: <span>2-5 business days</span>");
  $('.product-description ul li:last-of-type').show();
}

function bundleAddKc(event, form, id) {
  var event = event || window.event,
      kc_id = ''
  event.preventDefault();
  if (document.getElementById('kardiacare-1-year-product').checked) {
    var kc_id = document.getElementById('kardiacare-1-year-product').value
  }
  if (kc_id !== '') {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        'quantity': 1,
        'id': kc_id
      },
      dataType: 'json',
      success: function() {
        form.submit();
      }
    });
  } else {
    form.submit();
  }
}